export default __webpack_public_path__ + "static/media/login.205ac396.png";